export const LEGAL_PATHS = {
  PRIVACY_POLICY: '/politica-de-privacidade',
  TERMS_OF_USE: '/termos-de-uso',
};

const SITE_URL = (
  process.env.REACT_APP_SITE_URL || 'https://giropagamentos.com.br'
).replace(/\/+$/, '');

export const SITE_LEGAL_ROUTES = {
  PRIVACY_POLICY: `${SITE_URL}${LEGAL_PATHS.PRIVACY_POLICY}`,
  TERMS_OF_USE: `${SITE_URL}${LEGAL_PATHS.TERMS_OF_USE}`,
};
